// extracted by mini-css-extract-plugin
module.exports =  {"personal-agreement":"a10a3f92e9--personal-agreement--LxRzB","dark":"a10a3f92e9--dark--ct6rX","personal-agreement-link":"a10a3f92e9--personal-agreement-link--kZgrX"};